import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import { AddJobs } from "../../../../components/svg/svgImageList";
import Button from "../../../../components/button/Button";
import WarningBeforeAction from "../../../../components/data-components/WarningBeforeAction";
import useThemeService from "../../../../services/theme-service/ThemeService";
import { translationService } from "../../../../services/translation/TranslationService";
import useModal from "../../../../components/dialog/useModal";
import useErrorHandler, {
  ApplicationError,
} from "../../../../services/error-handler/ErrorHandlerService";
import { JobActionProps } from "./JobActionProps";

export const TakeJobButton = observer(
  ({ disabled = true, isHidden, currentJobStorage }: JobActionProps) => {
    const { isVisible, toggleModal } = useModal();
    const { themeClass } = useThemeService();
    const { handleErrorInSnackbar } = useErrorHandler();

    const doAction = useCallback(async () => {
      try {
        await currentJobStorage.takeJob();
      } catch (error) {
        const applicationError = error as ApplicationError;
        applicationError.withErrorMessage("default-error.job.take-job");
        handleErrorInSnackbar(applicationError);
      }
      toggleModal();
    }, [toggleModal, currentJobStorage, handleErrorInSnackbar]);

    return (
      <>
        <Button
          id="take-job"
          disabled={disabled}
          isHidden={isHidden}
          icon={{
            svg: AddJobs,
            textKey: "jobs.TakeJobButton.label",
            textClass: "actions-header-button-label",
            className: themeClass(["icon-take-job"]),
          }}
          onClick={toggleModal}
        />
        <WarningBeforeAction
          titleKey="jobs.TakeJobButton.warning-questions"
          buttonOk={{
            id: "ok-take-job",
            textKey: "jobs.TakeJobButton.label",
            action: doAction,
          }}
          isVisible={isVisible}
          toggleModal={toggleModal}
        >
          <p>{translationService.translate("jobs.TakeJobButton.are-you-sure-line1")}</p>
          <p>{translationService.translate("jobs.confirmation-action-change-information")}</p>
        </WarningBeforeAction>
      </>
    );
  }
);
